import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "default-content" }
const _hoisted_3 = { class: "info-box" }
const _hoisted_4 = { class: "test-name" }
const _hoisted_5 = { class: "test-label" }
const _hoisted_6 = { class: "test-name" }
const _hoisted_7 = { class: "test-label" }
const _hoisted_8 = { class: "test-label" }
const _hoisted_9 = { class: "button-bar" }
const _hoisted_10 = { class: "question-header" }
const _hoisted_11 = { class: "question-options" }
const _hoisted_12 = { class: "option-list" }
const _hoisted_13 = { class: "option-text" }

export function render(_ctx, _cache) {
  const _component_Header = _resolveComponent("Header")
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_button = _resolveComponent("el-button")
  const _component_Check = _resolveComponent("Check")
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_Close = _resolveComponent("Close")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["windowWidth", "windowHeight"]),
    _createVNode(_component_Navigation, {
      activeMenu: _ctx.NavigationIndex.TEST,
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["activeMenu", "windowWidth", "windowHeight"]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createElementVNode("div", { class: "danger" }, [
                  _createElementVNode("h4", null, "Zugang verweigert."),
                  _createElementVNode("p", null, "Sie besitzen nicht die erforderliche Berechtigung für diesen Bereich.")
                ], -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, !_ctx.hasPermission['TEST_UPDATE'] && !_ctx.hasPermission['TEST_QUESTION'] && !_ctx.loading]
        ]),
        (_ctx.testModel)
          ? (_openBlock(), _createBlock(_component_Breadcrumbs, {
              key: 0,
              breadcrumbs: [['Prüfungen', '/test'], [_ctx.testName, ('/test/'+_ctx.testModel.testid)], ['Fragebogen']]
            }, null, 8, ["breadcrumbs"]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, { class: "rounded-content" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.testName), 1)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        span: 12,
                        align: "right"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            _cache[2] || (_cache[2] = _createTextVNode(" am ")),
                            _createElementVNode("span", _hoisted_7, _toDisplayString(new Intl.DateTimeFormat('de-DE', {year: 'numeric', month: '2-digit', day: '2-digit'}).format(new Date(0).setUTCSeconds(_ctx.testDate))), 1),
                            _cache[3] || (_cache[3] = _createTextVNode(" um ")),
                            _createElementVNode("span", _hoisted_8, _toDisplayString(new Intl.DateTimeFormat('de-DE', {hour: '2-digit', minute: '2-digit'}).format(new Date(0).setUTCSeconds(_ctx.testDate))) + " Uhr", 1)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "step-container" }, null, -1)),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _ctx.onBackClick
                  }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createTextVNode("Zurück zur Prüfung")
                    ])),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.hasPermission['TEST_UPDATE'] || _ctx.hasPermission['TEST_QUESTION']]
        ])
      ]),
      _createVNode(_component_el_dialog, {
        title: "",
        modelValue: _ctx.showQuestionPreview,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.showQuestionPreview) = $event)),
        top: "70px",
        width: "80%",
        "show-close": false,
        modal: true,
        "modal-class": "no-back",
        center: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.questionName), 1),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [
            (!_ctx.loadingOptions)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.optionModelList, (item) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 0.1 }, {
                            default: _withCtx(() => [
                              (item.iscorrect)
                                ? (_openBlock(), _createBlock(_component_el_icon, {
                                    key: 0,
                                    class: "correct"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Check)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (!item.iscorrect)
                                ? (_openBlock(), _createBlock(_component_el_icon, {
                                    key: 1,
                                    class: "correct"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Close)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, { span: 0.1 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.position) + ".  ", 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, { span: 20 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.option), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]))
                }), 256))
              : _createCommentVNode("", true)
          ])), [
            [_directive_loading, _ctx.loadingOptions]
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])), [
      [_directive_loading, _ctx.loading]
    ])
  ], 64))
}